import { render, staticRenderFns } from "./HotelPrepositions.vue?vue&type=template&id=bb20c8e2&scoped=true&"
import script from "./HotelPrepositions.vue?vue&type=script&lang=js&"
export * from "./HotelPrepositions.vue?vue&type=script&lang=js&"
import style1 from "./HotelPrepositions.vue?vue&type=style&index=1&id=bb20c8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb20c8e2",
  null
  
)

export default component.exports